import core from './core.js';
import xml_1 from './languages/xml.js';
import bash_1 from './languages/bash.js';
import c_1 from './languages/c.js';
import cpp_1 from './languages/cpp.js';
import csharp_1 from './languages/csharp.js';
import css_1 from './languages/css.js';
import markdown_1 from './languages/markdown.js';
import diff_1 from './languages/diff.js';
import ruby_1 from './languages/ruby.js';
import go_1 from './languages/go.js';
import graphql_1 from './languages/graphql.js';
import ini_1 from './languages/ini.js';
import java_1 from './languages/java.js';
import javascript_1 from './languages/javascript.js';
import json_1 from './languages/json.js';
import kotlin_1 from './languages/kotlin.js';
import less_1 from './languages/less.js';
import lua_1 from './languages/lua.js';
import makefile_1 from './languages/makefile.js';
import perl_1 from './languages/perl.js';
import objectivec_1 from './languages/objectivec.js';
import php_1 from './languages/php.js';
import phpTemplate_1 from './languages/php-template.js';
import plaintext_1 from './languages/plaintext.js';
import python_1 from './languages/python.js';
import pythonRepl_1 from './languages/python-repl.js';
import r_1 from './languages/r.js';
import rust_1 from './languages/rust.js';
import scss_1 from './languages/scss.js';
import shell_1 from './languages/shell.js';
import sql_1 from './languages/sql.js';
import swift_1 from './languages/swift.js';
import yaml_1 from './languages/yaml.js';
import typescript_1 from './languages/typescript.js';
import vbnet_1 from './languages/vbnet.js';
import wasm_1 from './languages/wasm.js';

var hljs = core;

hljs.registerLanguage('xml', xml_1);
hljs.registerLanguage('bash', bash_1);
hljs.registerLanguage('c', c_1);
hljs.registerLanguage('cpp', cpp_1);
hljs.registerLanguage('csharp', csharp_1);
hljs.registerLanguage('css', css_1);
hljs.registerLanguage('markdown', markdown_1);
hljs.registerLanguage('diff', diff_1);
hljs.registerLanguage('ruby', ruby_1);
hljs.registerLanguage('go', go_1);
hljs.registerLanguage('graphql', graphql_1);
hljs.registerLanguage('ini', ini_1);
hljs.registerLanguage('java', java_1);
hljs.registerLanguage('javascript', javascript_1);
hljs.registerLanguage('json', json_1);
hljs.registerLanguage('kotlin', kotlin_1);
hljs.registerLanguage('less', less_1);
hljs.registerLanguage('lua', lua_1);
hljs.registerLanguage('makefile', makefile_1);
hljs.registerLanguage('perl', perl_1);
hljs.registerLanguage('objectivec', objectivec_1);
hljs.registerLanguage('php', php_1);
hljs.registerLanguage('php-template', phpTemplate_1);
hljs.registerLanguage('plaintext', plaintext_1);
hljs.registerLanguage('python', python_1);
hljs.registerLanguage('python-repl', pythonRepl_1);
hljs.registerLanguage('r', r_1);
hljs.registerLanguage('rust', rust_1);
hljs.registerLanguage('scss', scss_1);
hljs.registerLanguage('shell', shell_1);
hljs.registerLanguage('sql', sql_1);
hljs.registerLanguage('swift', swift_1);
hljs.registerLanguage('yaml', yaml_1);
hljs.registerLanguage('typescript', typescript_1);
hljs.registerLanguage('vbnet', vbnet_1);
hljs.registerLanguage('wasm', wasm_1);

hljs.HighlightJS = hljs;
hljs.default = hljs;
var common = hljs;

var HighlightJS = common;

export { HighlightJS as default };
